import { ApiNamespaces, IQueuedRequest, OneAPIOptions } from '../../common'
import { AppTenantsApi } from './app'
import { BackofficeTenantsApi } from './backoffice'
import { Queue } from '../../queue'

export class Tenants implements ApiNamespaces {
  app: AppTenantsApi
  backoffice: BackofficeTenantsApi
  constructor(
    name: string,
    sessionId: string,
    requestsQueue: Queue<IQueuedRequest>,
    options?: OneAPIOptions
  ) {
    this.app = new AppTenantsApi(name, sessionId, requestsQueue, options)
    this.backoffice = new BackofficeTenantsApi(
      name,
      sessionId,
      requestsQueue,
      options
    )
  }

  invalidateAll() {
    this.app.invalidateAll()
    this.backoffice.invalidateAll()
  }
}
